var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadedCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    fill: "#6FCF97"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0484 7.27163L8.43746 12.7611L6.61826 10.9812C6.24805 10.6191 5.64787 10.6191 5.27766 10.9812C4.90745 11.3434 4.90745 11.9306 5.27766 12.2928L7.76716 14.7284C8.13737 15.0905 8.73754 15.0905 9.10776 14.7284L15.389 8.58318C15.7592 8.22101 15.7592 7.63381 15.389 7.27163C15.0188 6.90946 14.4186 6.90946 14.0484 7.27163Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadedCheckIcon);
export default __webpack_public_path__ + "static/media/uploadedCheckIcon.f208eb58c19521a5820e4b6c9e16f3f3.svg";
export { ForwardRef as ReactComponent };